import { useArticles } from "@faire/help-center-utils/hooks/article/useArticles";
import { useStrictLocalization } from "@faire/web/common/localization";
import { addOrEditItems } from "../../instantAnswers/orders-addOrEditItems";
import { cancelOrder } from "../../instantAnswers/orders-cancelOrder";
import { combineOrders } from "../../instantAnswers/orders-combineOrders";
import { editOrderInformation } from "../../instantAnswers/orders-editOrderInformation";
import { RequestCommissionChanges } from "../../instantAnswers/orders-requestCommissionChanges";
import { splitOrder } from "../../instantAnswers/orders-splitOrder";
import { vatIssueIA } from "../../instantAnswers/orders-vatIssue";
import { orderUnfulfilledStateVisibilityFn } from "../../visibilityFunctions/orderStateVisibilityFn";
export var useOrderUnfulfilledBrandNodes = function useOrderUnfulfilledBrandNodes() {
  var _useStrictLocalizatio = useStrictLocalization(),
    strictLocalize = _useStrictLocalizatio.strictLocalize;
  var articles = useArticles();
  return {
    AddOrEditItemsUnfulfilledState: {
      id: "AddOrEditItemsUnfulfilledState",
      label: strictLocalize({
        id: "XOqOmK",
        defaultMessage: [{
          "type": 0,
          "value": "Artikelen aan bestelling toevoegen of bewerken"
        }]
      }),
      level: 2,
      isNodeVisible: orderUnfulfilledStateVisibilityFn,
      instantAnswer: addOrEditItems(strictLocalize),
      articles: [articles.FulfillingOrders.EDIT_RETAILER_ORDER]
    },
    EditOrderInformationUnfulfilledState: {
      id: "EditOrderInformationUnfulfilledState",
      label: strictLocalize({
        id: "Au/+F5",
        defaultMessage: [{
          "type": 0,
          "value": "Bestellingsgegevens bewerken"
        }]
      }),
      level: 2,
      isNodeVisible: orderUnfulfilledStateVisibilityFn,
      instantAnswer: editOrderInformation(strictLocalize),
      articles: [articles.FulfillingOrders.EDIT_RETAILER_ORDER]
    },
    VatIssueUnfulfilledState: {
      id: "VatIssueUnfulfilledState",
      label: strictLocalize({
        id: "kUcbVP",
        defaultMessage: [{
          "type": 0,
          "value": "Probleem met btw"
        }]
      }),
      level: 2,
      instantAnswer: vatIssueIA(strictLocalize),
      articles: [articles.International.VAT_WORK_EU_ORDERS, articles.International.PAY_VAT_NON_EU, articles.International.VAT_WORK_NON_EU_ORDERS],
      isNodeVisible: orderUnfulfilledStateVisibilityFn
    },
    SplitOrderUnfulfilledState: {
      id: "SplitOrderUnfulfilledState",
      label: strictLocalize({
        id: "wxYTQH",
        defaultMessage: [{
          "type": 0,
          "value": "Bestelling splitsen"
        }]
      }),
      level: 2,
      instantAnswer: splitOrder(strictLocalize),
      articles: [articles.FulfillingOrders.SPLIT_ATS_ORDER, articles.FulfillingOrders.SPLIT_PREORDER],
      isNodeVisible: orderUnfulfilledStateVisibilityFn
    },
    CombineOrdersUnfulfilledState: {
      id: "CombineOrdersUnfulfilledState",
      label: strictLocalize({
        id: "djrYpe",
        defaultMessage: [{
          "type": 0,
          "value": "Bestellingen combineren"
        }]
      }),
      level: 2,
      instantAnswer: combineOrders(strictLocalize),
      articles: [articles.FulfillingOrders.EDIT_RETAILER_ORDER],
      isNodeVisible: orderUnfulfilledStateVisibilityFn
    },
    RequestCommissionChangesUnfulfilledState: {
      id: "RequestCommissionChangesUnfulfilledState",
      label: strictLocalize({
        id: "/jYVoe",
        defaultMessage: [{
          "type": 0,
          "value": "Commissiewijziging aanvragen"
        }]
      }),
      level: 2,
      isNodeVisible: orderUnfulfilledStateVisibilityFn,
      instantAnswer: RequestCommissionChanges(strictLocalize),
      articles: [articles.FaireDirect.ZERO_COMMISSION]
    },
    CancelOrderUnfulfilledState: {
      id: "CancelOrderUnfulfilledState",
      label: strictLocalize({
        id: "CJTXVi",
        defaultMessage: [{
          "type": 0,
          "value": "Bestelling annuleren"
        }]
      }),
      level: 2,
      isNodeVisible: orderUnfulfilledStateVisibilityFn,
      instantAnswer: cancelOrder(strictLocalize),
      articles: [articles.FulfillingOrders.FULFILLING_ORDER]
    }
  };
};